import { Components, Theme, chipClasses as MuiChipClasses } from '@mui/material';

export const CHIP_SMALL_HEIGHT = '20px';

export const MuiChip: Components<Theme>['MuiChip'] = {
  defaultProps: {
    variant: 'filled',
    size: 'small',
  },
  styleOverrides: {
    root: {
      borderRadius: '4px',
    },
    sizeSmall: {
      height: CHIP_SMALL_HEIGHT,
    },
    deleteIcon: ({ theme }) => ({
      padding: '2px',
      color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.bold : theme.palette.text.secondary,
    }),
    icon: ({ theme }) => ({
      color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.default : theme.palette.text.primary,
      width: '12px',
      height: '12px',
    }),
    iconSmall: ({ theme }) => ({
      marginLeft: theme.spacing(1),
    }),
    labelSmall: {
      fontSize: '12px',
    },
    // Represents default static chips and selected chips
    filled: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          backgroundColor: theme.palette.interactive.neutral.default,
          border: `1px solid ${theme.palette.border.prominent}`,
          color: theme.palette.text.default,
          '&:hover, &:focus': {
            backgroundColor: theme.palette.background.hover,
          },
          [`&.${MuiChipClasses.disabled}`]: {
            opacity: 1,
            color: theme.palette.text.disabled,
            [`& .${MuiChipClasses.deleteIcon}`]: {
              color: theme.palette.text.disabled,
            },
            [`& .${MuiChipClasses.icon}`]: {
              color: theme.palette.text.disabled,
            },
          },
        };
      }

      const darkModeBackgroundColor =
        theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.status.default.lowContrast;

      return {
        backgroundColor: darkModeBackgroundColor,
        border: `1px solid ${darkModeBackgroundColor}`,
        color: theme.palette.text.primary,
        [`& .${MuiChipClasses.icon}`]: {
          color: theme.palette.text.primary,
        },
      };
    },
    // Represents chips that are selectable but are not currently selected
    outlined: ({ theme }) => ({
      backgroundColor: theme.featureFlags.panwRebrandStubYear ? undefined : theme.palette.background.container,
      border: `1px solid ${theme.palette.border.subtle}`,
      color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.default : theme.palette.text.secondary,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.background.hover,
      },
      [`& .${MuiChipClasses.icon}`]: {
        color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.bold : theme.palette.text.secondary,
      },
    }),
  },
};
